import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CompartmentItemFacade } from './compartment-item.facade';
import { setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class CompartmentItemGuard {
  constructor(private compartmentItemFacade: CompartmentItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { compartmentId },
    } = route;
    this.compartmentItemFacade.setCompartmentId(compartmentId);
    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.compartmentItemFacade);
  }
}
